"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ToolbarRegion: true
};
exports.default = exports.ToolbarRegion = void 0;
var _react = _interopRequireDefault(require("react"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _ToolbarRegion2 = require("./_ToolbarRegion.types");
Object.keys(_ToolbarRegion2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToolbarRegion2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToolbarRegion2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-toolbar';
const _ToolbarRegion = displayName => {
  const ToolbarRegion = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
    var _a;
    const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
    const _props = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(ToolbarRegion, props)) : props;
    const {
        className
      } = _props,
      otherProps = __rest(_props, ["className"]);
    const classnames = _bind.default.bind(_Toolbar.default);
    return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
      className: classnames(`${CSS_BLOCK}__${(_a = displayName === null || displayName === void 0 ? void 0 : displayName.split('.')[1]) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`, className),
      ref: ref
    }));
  });
  ToolbarRegion.displayName = displayName;
  return ToolbarRegion;
};
const ToolbarRegion = exports.ToolbarRegion = _ToolbarRegion;
var _default = exports.default = ToolbarRegion;